import type { BadgeGroupBlock, Badge as BadgeBlock } from '../../../types/investigator';
import { Badge, type BadgeTone } from '../../ui/badge';

// info/warning/critical/success are status roles, mapped to the nearest
// Badge tone. `inferred` is a provenance tier, so its colour comes from the
// shared colors module via the `provenance` prop.
const VARIANT_TONE: Record<Exclude<BadgeBlock['variant'], 'inferred'>, BadgeTone> = {
  info: 'info',
  warning: 'warning',
  critical: 'destructive',
  success: 'success',
};

interface BadgeGroupProps {
  block: BadgeGroupBlock;
}

export default function BadgeGroup({ block }: BadgeGroupProps) {
  if (block.badges.length === 0) return null;

  return (
    <div className="flex flex-wrap gap-2">
      {block.badges.map((badge, i) => (
        <Badge
          key={i}
          tone={badge.variant === 'inferred' ? 'neutral' : VARIANT_TONE[badge.variant]}
          provenance={badge.variant === 'inferred' ? 'inferred' : undefined}
        >
          {badge.label}
        </Badge>
      ))}
    </div>
  );
}
